import React from "react";
import { Link } from "react-router-dom";
import { tracks } from "../data";

export default function TrendingTracks() {
  return (
    <section className="mu-section" id="trending">
      <div className="container">
        <div className="section-head-row">
          <div>
            <div className="mu-eyebrow">Fresh Drops</div>
            <h2 className="section-title">Trending Right Now</h2>
            <p className="section-sub">
              The hottest tracks making waves across genres. Stream, discover, and support
              artists pushing the culture forward.
            </p>
          </div>
          <Link to="/music" className="btn-mu-outline">View All Music &rarr;</Link>
        </div>

        <div className="row g-4">
          {tracks.map((t) => (
            <div className="col-6 col-lg-3" key={t.id}>
              <Link to={`/music/${t.slug}`} className="track-card-link">
                <div className="track-card">
                  <div className="track-art">
                    <img src={t.img} alt={t.title} />
                    <div className="vinyl">
                      <div className="vinyl-disc"></div>
                    </div>
                    <span className="track-genre-badge">{t.genre}</span>
                  </div>
                  <div className="track-info">
                    <div className="track-title">{t.title}</div>
                    <div className="track-meta">{t.artist} · {t.releaseDate}</div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
